export default __webpack_public_path__ + "maps-examples-restrict-coordinate-bounds-1200-4a00fa6a8821a8eebc926be28e2ccaae.png";